/** Check the target window before registering fonts or creating components. */
export function supportsNavigation(window) {
  const element = window?.Element?.prototype;
  const dialog = window?.HTMLDialogElement?.prototype;
  if (typeof window?.HTMLElement !== 'function'
    || typeof window?.customElements?.define !== 'function'
    || typeof window.customElements.get !== 'function'
    || typeof element?.attachShadow !== 'function'
    || typeof element.replaceChildren !== 'function'
    || typeof dialog?.showModal !== 'function'
    || typeof dialog.close !== 'function'
    || typeof window.matchMedia !== 'function'
    || typeof window.queueMicrotask !== 'function'
    || typeof window.CSS?.supports !== 'function') return false;

  const media = window.matchMedia('(max-width: 1023px)');
  return typeof media?.addEventListener === 'function'
    && typeof media.removeEventListener === 'function';
}
